// Product-tour analytics (VRG-267) — react-query hook for the internal Tours tab.
import { useQuery } from '@tanstack/react-query'

import { tourAnalyticsApi } from 'services'

/**
 * The 30-day funnel + cross-tour summary, optionally scoped to one person.
 *
 * `staleTime` is 5 minutes, matching the API's own cache TTL. Two layers is not
 * belt-and-braces: without the client one, every tab switch fires a request that
 * the server answers from cache anyway — correct, but a round trip per click for a
 * number that cannot have changed. Without the server one, two staffers looking at
 * the same page each run the aggregates.
 *
 * `retry: false` — a 403 (no `internal_analytics_view`) is a settled answer, not a
 * transient failure, and retrying it three times only delays showing the user why
 * they cannot see the page.
 */
export const useTourAnalytics = (userEmail?: string) =>
  useQuery({
    queryKey: ['internal', 'tour-analytics', userEmail ?? 'all'],
    queryFn: () => tourAnalyticsApi.analytics(userEmail),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
